import { GET } from "../../APiHelper/API";

export const checkDuplicatePlayer = (team_id, wy_id, onSuccess, onError) => {
  GET(
    `/api/v1/leagues/team/${team_id}/duplicate_player?wy_id=${wy_id}`,
    onSuccess,
    onError
  );
};
